const MeasurementType = Object.freeze({
  STAR: 'Star',
  STAR_OV: 'StarOV',
  SURVEY: 'Survey',
  SURVEY_OV: 'SurveyOV',
  NPS: 'NPS'
})
export default MeasurementType
export type MeasurementTypeStrings = typeof MeasurementType[keyof typeof MeasurementType]
// RESERVE BELOW
